module.exports = __webpack_public_path__ + "static/fire_giant-a8c13a1e8f466f6ce5aefaff59d86977.jpg";